import io from "socket.io-client";
import React from "react";
export const socket = io.connect("http://localhost:8080");
export const SocketContext = React.createContext();
